import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import {
  UserAll,
  ManagerGetPlayerRequest,
  managerApproval,
  ManagerGetPlayerRequestData,
} from "../../redux/auth-reducer/auth-service";
import { Footer } from "../../Footer";
import TopNavbar from "../../CommonComponent/topNavbar/TopNavbar";
import Sidebar from "../../CommonComponent/sidebar/Sidebar";
import dayjs from "dayjs";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import * as icons from "react-bootstrap-icons";
import { ToastContainer, toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";

export const UserSuper = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [data, setData] = useState(false);
  const [apiData, setApiData] = useState([]);
  const [approvedPlayer, setApprovedlayer] = useState([]);
  const [pendingPlayer, setPendinglayer] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [approvedsearchText, setApprovedsearchText] = useState("");
  const [pendingsearchText, setPendingsearchText] = useState("");
  const [count, setCount] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [totalRows, setTotalRows] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const pageOptions = [10, 20, 30, 50];
  // #218: the tab shown. A subscription request on the bell or the Notifications page opens this
  // page with `targetTab: "Pending"` in the router state; otherwise it opens on All, as it always
  // did - the tabs were uncontrolled, so the "activeTabPlayer" key this used to keep in
  // localStorage never chose the tab shown.
  const [key, setKey] = useState(() => location.state?.targetTab || "All");

  // #218: keyed on location.key, so a bell entry also switches the tab when this page is already
  // open, and the state is then cleared, or a reload would apply it again (as in useAuctionList).
  useEffect(() => {
    const targetTab = location.state?.targetTab;
    if (!targetTab) return;

    setKey(targetTab);
    navigate(location.pathname + location.search, { replace: true, state: null });
    // Only a new arrival may apply it: the clearing navigate above is itself a location change.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.key]);
  function sidebarfun() {
    setData(!data);
  }
  const caseInsensitiveSort = (rowA, rowB) => {
    const a = rowA?.firstName?.toLowerCase();
    const b = rowB?.firstName?.toLowerCase();

    if (a > b) {
      return 1;
    }

    if (b > a) {
      return -1;
    }

    return 0;
  };
  function convertUTCToLocalTime(utcDateString) {
    const date = new Date(utcDateString);
    return date.toString(); // Or use date.toLocaleString() for better format
  }
  const columns = [
    {
      name: <strong>Id</strong>,
      selector: (row, index) => index + 1,
      sortable: true,
      width: "80px",
    },
    {
      name: <strong>Name</strong>,
      selector: (row) => <>{row?.playerName}</>,
      sortable: true,
      sortFunction: caseInsensitiveSort,
    },

    {
      name: <strong>Email</strong>,
      selector: (row) => {
        return row?.playerEmailId;
      },
      sortable: true,
    },

    {
      name: <strong>Join Date & Time</strong>,
      selector: (row) => {
        if (!row?.requestDate) return <p>Invalid date</p>;

        return (
          <p>{dayjs(row?.requestDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}</p>
        );
      },
    },
    {
      name: <strong>Status</strong>,
      selector: (row) => (
        <>
          {row.status == "Approved" ? (
            <div className="bg-succ">Approved</div>
          ) : row.status == "Pending" ? (
            <div className="bg-succ">Pending</div>
          ) : (
            <div className="bg-dang">Declined</div>
          )}
        </>
      ),
      width: "200px",
    },
  ];

  const approveManager = async (playerId, approval) => {
    await managerApproval(playerId, approval).then((response) => {
      if (response.status == true) {
        setCount(1);
        toast.success(response?.message);
      } else {
        toast.error(response?.message);
      }
    });
  };

  const handleApprove = (id) => {
    approveManager(id, true);
  };
  const handleDecline = (id) => {
    approveManager(id, false);
  };

  const ApprovedColumns = [
    {
      name: <strong>Id</strong>,
      selector: (row, index) => (currentPage - 1) * perPage + index + 1,

      width: "80px",
    },
    {
      name: <strong>Name</strong>,
      selector: (row) => <>{row?.playerName}</>,
      sortable: true,
      sortFunction: caseInsensitiveSort,
    },

    {
      name: <strong>Request Date & Time</strong>,
      selector: (row) => {
        if (!row?.requestDate) return <p>Invalid date</p>;

        return (
          <p>{dayjs(row?.requestDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}</p>
        );
      },
    },

    {
      name: <strong>Response Date & Time</strong>,
      selector: (row) => {
        if (!row?.responseDate) return <p>Invalid date</p>;

        return (
          <p>
            {dayjs(row?.responseDate + "Z").format("MM/DD/YYYY hh:mm:ss A")}
          </p>
        );
      },
    },

    {
      name: <strong>Status</strong>,
      selector: (row) => (
        <>
          {row.status == "Approved" ? (
            <div className="bg-succ">Approved</div>
          ) : (
            <div className="bg-dang">Pending</div>
          )}
        </>
      ),
      width: "200px",
    },
  ];

  const PendingColumns = [
    {
      name: <strong>Id</strong>,
      selector: (row, index) => index + 1,

      width: "80px",
    },
    {
      name: <strong>Name</strong>,
      selector: (row) => <>{row?.playerName}</>,
      sortable: true,
      sortFunction: caseInsensitiveSort,
    },

    {
      name: <strong>Requested Date</strong>,
      selector: (row) =>
        dayjs(row?.requestDate).format("MM/DD/YYYY hh:mm:ss A"),
      sortable: true,
    },

    {
      name: <strong>Status</strong>,
      selector: (row) => (
        <>
          {row.status == "Pending" ? (
            <div className="bg-succ">Pending</div>
          ) : (
            <div className="bg-dang">Declined</div>
          )}
        </>
      ),
      width: "200px",
    },

    {
      name: <strong>Action</strong>,
      selector: (row) => (
        <>
          {row.status == "Pending" ? (
            <>
              <button
                className="bg-succ"
                onClick={() => handleApprove(row?.playerId, true)}
              >
                Approve
              </button>
              <button
                className="bg-dang"
                onClick={() => handleDecline(row?.playerId, false)}
              >
                Decline
              </button>
            </>
          ) : row.status == "Declined" ? (
            <button
              className="bg-succ"
              onClick={() => handleApprove(row?.playerId, true)}
            >
              Enable
            </button>
          ) : (
            ""
          )}
        </>
      ),
    },
  ];
  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleApprovedSearch = (e) => {
    setApprovedsearchText(e.target.value);
  };
  const handlePendingSearch = (e) => {
    setPendingsearchText(e.target.value);
  };

  // const filteredData = searchText
  //   ? apiData.filter((item) => {
  //       const fullName = `${item?.firstName || ""} ${
  //         item?.lastName || ""
  //       }`.toLowerCase();
  //       return (
  //         fullName?.includes(searchText?.toLowerCase()) ||
  //         item?.emailId?.includes(searchText?.toLowerCase())
  //       );
  //     })
  //   : apiData;

  const filteredData = searchText
    ? apiData.filter((item) => {
        const fullName = item.playerName.toLowerCase();
        return (
          fullName.includes(searchText.toLowerCase()) ||
          item.playerEmailId.includes(searchText.toLowerCase())
        );
      })
    : apiData;

  const approvedFilteredData = approvedsearchText
    ? approvedPlayer?.filter((item) => {
        return item?.playerName
          ?.toLowerCase()
          .includes(approvedsearchText?.toLowerCase());
      })
    : approvedPlayer;

  const pendingFilteredData = pendingsearchText
    ? pendingPlayer.filter((item) => {
        return item?.playerName
          ?.toLowerCase()
          .includes(pendingsearchText?.toLowerCase());
      })
    : pendingPlayer;

  const isUser = JSON.parse(localStorage.getItem("isUser"));
  const managerId = isUser?.userId;

  // const TeamAllFn = async (data) => {
  //   try {
  //     const response = await ManagerGetPlayerRequestData(data); // Call your API function
  //     if (response?.data) {
  //       const ApprovedPlayers = response?.data?.filter(
  //         (player) => player?.status === "Approved"
  //       );
  //       const PendingPlayers = response?.data?.filter(
  //         (player) =>
  //           player?.status === "Pending" || player?.status === "Declined"
  //       );
  //       setApiData([...ApprovedPlayers, ...PendingPlayers]);
  //       setApprovedlayer(ApprovedPlayers);
  //       setPendinglayer(PendingPlayers);
  //       setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
  //     }
  //   } catch (error) {
  //     console.error("Error fetching data:", error);
  //   }
  // };

 const TeamAllFn = async (data) => {
  try {
    const response = await ManagerGetPlayerRequestData(data); // Call your API function
    if (response?.data) {
      const ApprovedPlayers = response?.data?.filter(
        (player) => player?.status === "Approved"
      );
      const PendingPlayers = response?.data?.filter(
        (player) =>
          player?.status === "Pending" || player?.status === "Declined"
      );

      // Combine the players
      const combinedPlayers = [...ApprovedPlayers, ...PendingPlayers];

      // Sort combined players by requestDate in descending order
      combinedPlayers.sort((a, b) => {
        const dateA = new Date(a.requestDate);
        const dateB = new Date(b.requestDate);
        return dateB - dateA; // Sort in descending order
      });

      setApiData(combinedPlayers);
      setApprovedlayer(ApprovedPlayers);
      setPendinglayer(PendingPlayers);
      setTotalRows(response.data.data.totalPageSize || 0); // Set the total number of rows
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};

  useEffect(() => {
    const data = {
      PageNumber: currentPage,
      PageSize: perPage,
      SortOrder: true,
    };
    if (key === "All") {
      TeamAllFn(data);
    } else if (key === "Approved") {
      TeamAllFn(data);
    } else if (key === "Pending")  {
      TeamAllFn(data);
    }else{
      TeamAllFn(data);
    }

    // Fetch data when currentPage changes
  }, [currentPage, count, key]);

  const handlePerPageChange = (event) => {
    const newPerPage = Number(event.target.value);
    const data = {
      PageNumber: currentPage,
      PageSize: newPerPage,
      SortOrder: true,
    };
    TeamAllFn(data);
    setPerPage(newPerPage); // Update items per page
    setCurrentPage(1); // Reset to first page when items per page changes
  };

  const handleNextPage = () => {
    if (currentPage < Math.ceil(totalRows)) {
      setCurrentPage((prevPage) => prevPage + 1); // Go to next page
    }
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1); // Go to previous page
    }
  };

  return (
    <>
      <TopNavbar sidebarfun={sidebarfun} />

      <div className="dasboard-group">
        <Sidebar data={data} />
        <div
          className={
            data ? "dashboard-content full-contnet" : "dashboard-content"
          }
        >
          <Row>
            <Col md="10">
              <h1 className="heading-dash">Player</h1>
            </Col>
            <Col md="2 text-right mb-3"></Col>
          </Row>

          <div className="group_data_table tabs-auction">
            <div className="tabs-box">
              <Tabs
                activeKey={key}
                id="auctiontabs"
                onSelect={(k) => setKey(k)}
                className="mb-0 tab-list-item"
                justify
              >
                <Tab eventKey="All" title="All">
                  <div>
                    <div className="auctiontabs player">
                      <div className="search-input d-flex align-items-center">
                        <input
                          type="text"
                          className="form-control mb-3 mt-3"
                          placeholder="Search..."
                          value={searchText}
                          onChange={handleSearch}
                        />
                        {searchText && (
                          <button className="btn btn-clear" onClick={() => setSearchText("")}>
                            <span>&times;</span>
                          </button>
                        )}
                      </div>

                      <div>
                        <DataTable
                          title="Player List"
                          columns={columns}
                          data={filteredData}
                          paginationPerPage={perPage}
                          paginationTotalRows={totalRows * 10}
                          paginationDefaultPage={currentPage}
                          onChangePage={setCurrentPage}
                        />
                        {totalRows > 1 && (
                          <Row>
                            <Col md={6}></Col>
                            <Col md={6} className="text-right">
                              <div className="pagination-controls">
                                <label>Rows page: </label>
                                <select
                                  id="itemsPerPage"
                                  value={perPage}
                                  onChange={handlePerPageChange}
                                >
                                  {pageOptions.map((option) => (
                                    <option key={option} value={option}>
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                <Button
                                  onClick={handlePreviousPage}
                                  disabled={currentPage === 1}
                                >
                                  <icons.ArrowLeft></icons.ArrowLeft>
                                </Button>
                                <span>
                                  {currentPage} of {totalRows}{" "}
                                </span>
                                <Button
                                  onClick={handleNextPage}
                                  disabled={currentPage >= Math.ceil(totalRows)}
                                >
                                  <icons.ArrowRight></icons.ArrowRight>
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        )}
                      </div>
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="Approved" title="Approved">
                  <div>
                    <div className="auctiontabs player">
                      <div className="search-input d-flex align-items-center">
                        <input
                          type="text"
                          className="form-control mb-3 mt-3"
                          placeholder="Search..."
                          value={approvedsearchText}
                          onChange={handleApprovedSearch}
                        />
                        {approvedsearchText && (
                          <button className="btn btn-clear" onClick={() => setApprovedsearchText("")}>
                            <span>&times;</span>
                          </button>
                        )}
                      </div>

                      <div>
                        <DataTable
                          title="Player List"
                          columns={ApprovedColumns}
                          data={approvedFilteredData}
                          paginationPerPage={perPage}
                          paginationTotalRows={totalRows * 10}
                          paginationDefaultPage={currentPage}
                          onChangePage={setCurrentPage}
                        />
                        {totalRows > 1 && (
                          <Row>
                            <Col md={12} className="text-right">
                              <div className="pagination-controls">
                                <label>Rows page: </label>
                                <select
                                  id="itemsPerPage"
                                  value={perPage}
                                  onChange={handlePerPageChange}
                                >
                                  {pageOptions.map((option) => (
                                    <option key={option} value={option}>
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                <Button
                                  onClick={handlePreviousPage}
                                  disabled={currentPage === 1}
                                >
                                  <icons.ArrowLeft></icons.ArrowLeft>
                                </Button>
                                <span>
                                  {currentPage} of {totalRows}{" "}
                                </span>
                                <Button
                                  onClick={handleNextPage}
                                  disabled={currentPage >= Math.ceil(totalRows)}
                                >
                                  <icons.ArrowRight></icons.ArrowRight>
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        )}
                      </div>
                    </div>
                  </div>
                </Tab>
                <Tab eventKey="Pending" title="Pending">
                  <div>
                    <div className="auctiontabs player">
                      <div className="search-input d-flex align-items-center">
                        <input
                          type="text"
                          className="form-control mb-3 mt-3"
                          placeholder="Search..."
                          value={pendingsearchText}
                          onChange={handlePendingSearch}
                        />
                        {pendingsearchText && (
                          <button className="btn btn-clear" onClick={() => setPendingsearchText("")}>
                            <span>&times;</span>
                          </button>
                        )}
                      </div>
                      <div>
                        <DataTable
                          title="Player List"
                          columns={PendingColumns}
                          data={pendingFilteredData}
                          paginationPerPage={perPage}
                          paginationTotalRows={totalRows * 10}
                          paginationDefaultPage={currentPage}
                          onChangePage={setCurrentPage}
                        />
                        {totalRows > 1 && (
                          <Row>
                            <Col md={12} className="text-right">
                              <div className="pagination-controls">
                                <label>Rows page: </label>
                                <select
                                  id="itemsPerPage"
                                  value={perPage}
                                  onChange={handlePerPageChange}
                                >
                                  {pageOptions.map((option) => (
                                    <option key={option} value={option}>
                                      {option}
                                    </option>
                                  ))}
                                </select>

                                <Button
                                  onClick={handlePreviousPage}
                                  disabled={currentPage === 1}
                                >
                                  <icons.ArrowLeft></icons.ArrowLeft>
                                </Button>
                                <span>
                                  {" "}
                                  {currentPage} of {totalRows}{" "}
                                </span>
                                <Button
                                  onClick={handleNextPage}
                                  disabled={currentPage >= Math.ceil(totalRows)}
                                >
                                  <icons.ArrowRight></icons.ArrowRight>
                                </Button>
                              </div>
                            </Col>
                          </Row>
                        )}
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>
            </div>
          </div>
        </div>
        <div className={data ? "footer" : "footer-content"}>
          <Footer />
        </div>
      </div>
    </>
  );
};
